import { isNotFoundError } from '@/services/api';

export type VehicleSearchErrorKind = 'not_found' | 'unavailable';

export const VEHICLE_SEARCH_ERROR_COPY: Record<VehicleSearchErrorKind, string> = {
    not_found: 'No vehicle found for this VIN or registration.',
    unavailable: 'Vehicle search is temporarily unavailable. Please try again shortly.',
};

export const vehicleSearchErrorKind = (error: unknown): VehicleSearchErrorKind | null => {
    if (!error) {
        return null;
    }

    return isNotFoundError(error) ? 'not_found' : 'unavailable';
};
